import React, { useEffect, useState } from 'react';
import { Layout, ConfigProvider, Breadcrumb, Card, Row, Col, Input, Button, Table, Spin, Drawer, Form, message, Popconfirm, InputNumber } from 'antd';
import esES from 'antd/lib/locale/es_ES';
import 'antd/dist/antd.css';
import reqwest from 'reqwest';
import moment from 'moment';
import MyMenu from '../../components/Menu';
import { getToken } from '../../Utils/common';
import { useHistory } from 'react-router-dom';
import config from '../../config';

const { Content, Sider } = Layout;

function Medications() {
  const history = useHistory();
  const [collapsed, setCollapsed] = useState(false);
  const [active, setActive] = useState(0);

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [searchText, setSearchText] = useState('');
  const [ordering, setOrdering] = useState('name');

  // Create/Edit drawer
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [saving, setSaving] = useState(false);
  const [editRecord, setEditRecord] = useState(null);
  const [form] = Form.useForm();

  // No separate stock drawer; stock is edited within the edit drawer

  const fetch = (params = {}) => {
    setLoading(true);
    const page = params.page || pagination.current;
    const pageSize = params.pageSize || pagination.pageSize;
    const offset = page > 1 ? pageSize * (page - 1) : 0;
    const search = params.search !== undefined ? params.search : searchText;
    const order = params.ordering || ordering;

    const qs = [`limit=${pageSize}`, `offset=${offset}`];
    if (search) qs.push(`search=${encodeURIComponent(search)}`);
    if (order) qs.push(`ordering=${encodeURIComponent(order)}`);

    reqwest({
      url: `${config.api_url}/medications/?${qs.join('&')}`,
      method: 'get',
      type: 'json',
      headers: { 'Authorization': `Token ${getToken()}` },
    }).then(resp => {
      setLoading(false);
      const results = resp.results || [];
      setData(results);
      setPagination(prev => ({ ...prev, current: page, pageSize, total: resp.count }));
    }).catch(error => {
      setLoading(false);
      if (error.status === 401) {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user');
        history.push('/login');
      } else {
        message.error(`Error al cargar medicamentos: ${error.status}`);
      }
    });
  };

  useEffect(() => { fetch({}); /* eslint-disable-next-line */ }, []);

  const onSearch = (val) => {
    setSearchText(val);
    fetch({ page: 1, search: val });
  };

  const handleTableChange = (pager, filters, sorter) => {
    let order = 'name';
    if (sorter && sorter.field) {
      order = (sorter.order === 'descend' ? '-' : '') + sorter.field;
    }
    setOrdering(order);
    fetch({ page: pager.current, pageSize: pager.pageSize, ordering: order });
  };

  const openCreate = () => {
    setEditRecord(null);
    form.resetFields();
    setDrawerVisible(true);
  };

  const openEdit = (record) => {
    setEditRecord(record);
    form.setFieldsValue({
      name: record.name,
      presentation: record.presentation,
      description: record.description,
      current_stock: record.current_stock,
    });
    setDrawerVisible(true);
  };

  const onSave = (values) => {
    setSaving(true);
    const payload = {
      name: values.name,
      presentation: values.presentation || null,
      description: values.description || null,
      current_stock: values.current_stock != null ? values.current_stock : 0,
    };
    const req = editRecord
      ? {
          url: `${config.api_url}/medications/${editRecord.id}/`,
          method: 'patch',
          data: payload,
        }
      : {
          url: `${config.api_url}/medications/`,
          method: 'post',
          data: payload,
        };
    reqwest({ ...req, type: 'json', headers: { 'Authorization': `Token ${getToken()}` }})
      .then(() => {
        setSaving(false);
        setDrawerVisible(false);
        form.resetFields();
        message.success(editRecord ? 'Medicamento actualizado' : 'Medicamento creado');
        fetch({});
      })
      .catch(error => {
        setSaving(false);
        if (error.status === 401) {
          sessionStorage.removeItem('token');
          sessionStorage.removeItem('user');
          history.push('/login');
        } else {
          // Try to parse validation errors
          const detail = (error.responseJSON && (error.responseJSON.detail || error.responseJSON.error)) || `Error: ${error.status}`;
          message.error(detail);
        }
      });
  };

  const onDelete = (record) => {
    return reqwest({
      url: `${config.api_url}/medications/${record.id}/`,
      method: 'delete',
      type: 'json',
      headers: { 'Authorization': `Token ${getToken()}` },
    }).then(() => {
      message.success('Medicamento eliminado');
      // Cerrar drawer si está abierto y limpiar estado de edición
      setDrawerVisible(false);
      setEditRecord(null);
      form.resetFields();
      fetch({});
    }).catch(error => {
      if (error.status === 401) {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user');
        history.push('/login');
      } else {
        message.error(`Error al eliminar: ${error.status}`);
      }
    });
  };

  // Stock is updated by editing the "Stock Actual" field in the edit drawer

  const columns = [
    { title: 'ID', dataIndex: 'id', sorter: true, width: '6%' },
    { title: 'Nombre', dataIndex: 'name', sorter: true },
    { title: 'Presentación', dataIndex: 'presentation', width: '20%' },
    { title: 'Descripción', dataIndex: 'description' },
    { title: 'Stock Actual', dataIndex: 'current_stock', sorter: true, width: '10%' },
  ];

  return (
    <ConfigProvider locale={esES}>
      <Layout style={{ minHeight: '100vh' }}>
        <Sider collapsible collapsed={collapsed} onCollapse={setCollapsed} className="no-print">
          <div className="logo" />
          <MyMenu active={active} />
        </Sider>
        <Layout className="site-layout">
          <Content style={{ margin: '0 16px' }}>
            <Breadcrumb style={{ margin: '16px 0' }}>
              <Breadcrumb.Item>Home</Breadcrumb.Item>
              <Breadcrumb.Item>Medicación</Breadcrumb.Item>
            </Breadcrumb>
            <div className="site-layout-background" style={{ padding: 24, minHeight: 360 }}>
              <Card title="Listado de Medicamentos" bordered={false}>
                <Row gutter={16} style={{ marginBottom: 16 }}>
                  <Col span={12}>
                    <Input.Search
                      placeholder="Buscar por nombre, presentación o descripción"
                      onSearch={onSearch}
                      allowClear
                    />
                  </Col>
                  <Col span={12}>
                    <Button type="primary" style={{ float: 'right' }} onClick={openCreate}>
                      Nuevo Medicamento
                    </Button>
                  </Col>
                </Row>
                <Spin spinning={loading}>
                  <Table
                    rowKey={r => r.id}
                    columns={columns}
                    dataSource={data}
                    pagination={pagination}
                    onChange={handleTableChange}
                    onRow={(record) => ({
                      onClick: () => openEdit(record),
                      style: { cursor: 'pointer' },
                    })}
                  />
                </Spin>
              </Card>
            </div>
          </Content>
        </Layout>
      </Layout>

      {/* Drawer for create/edit */}
      <Drawer
        title={editRecord ? `Editar Medicamento #${editRecord.id}` : 'Nuevo Medicamento'}
        width={520}
        visible={drawerVisible}
        onClose={() => { setDrawerVisible(false); form.resetFields(); }}
        destroyOnClose
        footer={
          <div style={{ textAlign: 'right' }}>
            {editRecord && (
              <Popconfirm title="¿Eliminar medicamento?" onConfirm={() => onDelete(editRecord)} okText="Sí" cancelText="No">
                <Button danger style={{ float: 'left' }}>Eliminar</Button>
              </Popconfirm>
            )}
            <Button onClick={() => { setDrawerVisible(false); form.resetFields(); }} style={{ marginRight: 8 }}>Cancelar</Button>
            <Button type="primary" loading={saving} onClick={() => form.submit()}>{editRecord ? 'Guardar' : 'Crear'}</Button>
          </div>
        }
      >
        <Form form={form} layout="vertical" onFinish={onSave}>
          <Form.Item name="name" label="Nombre" rules={[{ required: true, message: 'Ingrese el nombre' }]}>
            <Input />
          </Form.Item>
          <Form.Item name="presentation" label="Presentación">
            <Input />
          </Form.Item>
          <Form.Item name="description" label="Descripción">
            <Input.TextArea rows={3} />
          </Form.Item>
          <Form.Item name="current_stock" label="Stock Actual">
            <InputNumber style={{ width: '100%' }} />
          </Form.Item>
        </Form>
      </Drawer>

    </ConfigProvider>
  );
}

export default Medications;
